"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTrySchema = void 0;
const baseSchema_1 = __importDefault(require("./baseSchema"));
class BaseTrySchema extends baseSchema_1.default {
    constructor({ result, statusCode, componentName, componentSource, failureDescription }) {
        super();
        this.result = result;
        this.statusCode = statusCode;
        this.componentName = componentName;
        this.componentSource = componentSource;
        this.failureDescription = failureDescription;
    }
    prepare() {
        return {
            ...super.prepare(),
            result: this.result,
            statusCode: this.statusCode,
            componentName: this.componentName,
            componentSource: this.componentSource,
            failureDescription: this.failureDescription
        };
    }
}
exports.BaseTrySchema = BaseTrySchema;
